import {educatAPI, RestQueryParams} from 'educat-common-web';
import {Observable} from 'rxjs';
import {IInquiryInput} from "../../model/inquiry";

export function createInquiryAPI(payload: IInquiryInput): Observable<any> {
    return educatAPI.post('inquiries', payload, new RestQueryParams(), {});
}